<template>
  <div class="analysis-skeleton" :class="secondary && 'analysis-skeleton--secondary'">
    <div
      v-for="(item, index) in props.list"
      :key="index"
      class="analysis-skeleton__item"
      :style="getItemStyle(item)"
    ></div>
  </div>
</template>

<script setup>
const props = defineProps({
  list: {
    type: Array,
    default: () => []
  },
  secondary: {
    type: Boolean,
    default: false
  }
})

const widthMap = {
  short: '50%',
  medium: '70%',
  full: '100%'
}

const getItemStyle = (item) => {
  const width = typeof item === 'string' ? item : item?.width
  return {
    width: widthMap[width] || width || '100%'
  }
}
</script>

<style lang="less" scoped>
.analysis-skeleton {
  display: flex;
  flex-direction: column;
  gap: 12px;

  &--secondary {
    padding-bottom: 12px;
  }

  &__item {
    position: relative;
    width: 100%;
    height: 23px;
    border-radius: 8px;
    overflow: hidden;
    background: #f2f3f5;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: -150%;
      width: 150%;
      height: 100%;
      background: linear-gradient(
        90deg,
        rgba(242, 243, 245, 0) 0%,
        rgba(255, 255, 255, 0.8) 50%,
        rgba(242, 243, 245, 0) 100%
      );
      animation: skeleton-shimmer 1.5s infinite;
    }
  }
}

@keyframes skeleton-shimmer {
  100% {
    left: 100%;
  }
}
</style>
